export const settingsMessages = {
  "lo": {
    "settings.title": "ການຕັ້ງຄ່າ",
    "settings.menu": "ເມນູການຕັ້ງຄ່າ",
    "settings.notifications": "ການແຈ້ງເຕືອນ",
    "settings.changePassword": "ປ່ຽນລະຫັດຜ່ານ",
    "settings.wallet": "ຈັດການກະເປົາເງິນ",
    "settings.language": "ປ່ຽນພາສາ",
    "settings.feedback": "ລາຍງານບັນຫາ",
    "settings.comingSoon": "ເປີດໃຊ້ພາຍຫຼັງ",
    "settings.comingSoonSentence": "ຟັງຊັນນີ້ຈະເປີດໃຊ້ໃນພາຍຫຼັງ.",
    "settings.currentPassword": "ລະຫັດຜ່ານປັດຈຸບັນ",
    "settings.newPassword": "ລະຫັດຜ່ານໃໝ່",
    "settings.confirmNewPassword": "ຢືນຢັນລະຫັດຜ່ານໃໝ່",
    "settings.savePassword": "ບັນທຶກລະຫັດຜ່ານ",
    "settings.passwordIncomplete": "ກະລຸນາຕື່ມລະຫັດຜ່ານໃຫ້ຄົບທຸກຊ່ອງ.",
    "settings.passwordMismatch": "ລະຫັດຜ່ານໃໝ່ທັງສອງບໍ່ກົງກັນ.",
    "settings.passwordUnchanged": "ລະຫັດຜ່ານໃໝ່ຕ້ອງຕ່າງຈາກລະຫັດຜ່ານປັດຈຸບັນ.",
    "settings.passwordUpdated": "ປ່ຽນລະຫັດຜ່ານແລ້ວ.",
    "settings.passwordFailed": "ປ່ຽນລະຫັດຜ່ານບໍ່ສຳເລັດ. ກະລຸນາກວດລະຫັດຜ່ານປັດຈຸບັນ ຫຼືລອງໃໝ່ພາຍຫຼັງ.",
    "settings.nlcBannedTitle": "ຖືກຫ້າມໃຊ້ NLC",
    "settings.nlcBannedPrefix": "ທ່ານຖືກຫ້າມໃຊ້ຟັງຊັນນີ້ ກະລຸນາຕິດຕໍ່ ",
    "settings.nlcStoppedPrefix": "ທ່ານຖືກຢຸດໃຊ້ຟັງຊັນນີ້ ກະລຸນາຕິດຕໍ່ ",
    "settings.officialSupport": "ພະນັກງານບໍລິການລູກຄ້າ",
    "settings.supportTitle": "ບໍລິການລູກຄ້າ",
    "settings.supportIntro": "ເລືອກພະນັກງານເພື່ອເລີ່ມສົນທະນາສ່ວນຕົວ.",
    "settings.supportLoading": "ກຳລັງໂຫຼດລາຍຊື່ພະນັກງານ…",
    "settings.supportEmpty": "ຂະນະນີ້ບໍ່ມີພະນັກງານບໍລິການລູກຄ້າ.",
    "settings.supportOnline": "ອອນລາຍ",
    "settings.supportOffline": "ບໍ່ອອນລາຍ",
    "settings.supportLoadFailed": "ໂຫຼດລາຍຊື່ພະນັກງານບໍ່ສຳເລັດ."
  },
  "km": {
    "settings.title": "ការកំណត់",
    "settings.menu": "ម៉ឺនុយការកំណត់",
    "settings.notifications": "ការជូនដំណឹង",
    "settings.changePassword": "ប្តូរពាក្យសម្ងាត់",
    "settings.wallet": "គ្រប់គ្រងកាបូប",
    "settings.language": "ប្តូរភាសា",
    "settings.feedback": "រាយការណ៍បញ្ហា",
    "settings.comingSoon": "បើកនៅពេលក្រោយ",
    "settings.comingSoonSentence": "មុខងារនេះនឹងបើកនៅពេលក្រោយ។",
    "settings.currentPassword": "ពាក្យសម្ងាត់បច្ចុប្បន្ន",
    "settings.newPassword": "ពាក្យសម្ងាត់ថ្មី",
    "settings.confirmNewPassword": "បញ្ជាក់ពាក្យសម្ងាត់ថ្មី",
    "settings.savePassword": "រក្សាទុកពាក្យសម្ងាត់",
    "settings.passwordIncomplete": "សូមបំពេញគ្រប់ប្រអប់ពាក្យសម្ងាត់។",
    "settings.passwordMismatch": "ពាក្យសម្ងាត់ថ្មីទាំងពីរមិនត្រូវគ្នា។",
    "settings.passwordUnchanged": "ពាក្យសម្ងាត់ថ្មីត្រូវខុសពីពាក្យសម្ងាត់បច្ចុប្បន្ន។",
    "settings.passwordUpdated": "បានប្តូរពាក្យសម្ងាត់។",
    "settings.passwordFailed": "មិនអាចប្តូរពាក្យសម្ងាត់បានទេ។ សូមពិនិត្យពាក្យសម្ងាត់បច្ចុប្បន្ន ឬសាកល្បងពេលក្រោយ។",
    "settings.nlcBannedTitle": "ការប្រើ NLC ត្រូវបានហាមឃាត់",
    "settings.nlcBannedPrefix": "អ្នកត្រូវបានហាមប្រើមុខងារនេះ។ សូមទាក់ទង ",
    "settings.nlcStoppedPrefix": "ការប្រើមុខងារនេះរបស់អ្នកត្រូវបានផ្អាក។ សូមទាក់ទង ",
    "settings.officialSupport": "បុគ្គលិកសេវាអតិថិជនផ្លូវការ",
    "settings.supportTitle": "សេវាអតិថិជនផ្លូវការ",
    "settings.supportIntro": "ជ្រើសរើសបុគ្គលិកដើម្បីចាប់ផ្តើមការសន្ទនាឯកជន។",
    "settings.supportLoading": "កំពុងផ្ទុកបញ្ជីបុគ្គលិក…",
    "settings.supportEmpty": "បច្ចុប្បន្នមិនមានបុគ្គលិកសេវាអតិថិជនទេ។",
    "settings.supportOnline": "អនឡាញ",
    "settings.supportOffline": "ក្រៅបណ្តាញ",
    "settings.supportLoadFailed": "មិនអាចផ្ទុកបញ្ជីបុគ្គលិកសេវាអតិថិជនបានទេ។"
  },
  "th": {
    "settings.title": "การตั้งค่า",
    "settings.menu": "เมนูการตั้งค่า",
    "settings.notifications": "การแจ้งเตือน",
    "settings.changePassword": "เปลี่ยนรหัสผ่าน",
    "settings.wallet": "จัดการกระเป๋าเงิน",
    "settings.language": "เปลี่ยนภาษา",
    "settings.feedback": "แจ้งปัญหา",
    "settings.comingSoon": "เปิดให้ใช้ภายหลัง",
    "settings.comingSoonSentence": "ฟีเจอร์นี้จะเปิดให้ใช้งานภายหลัง",
    "settings.currentPassword": "รหัสผ่านปัจจุบัน",
    "settings.newPassword": "รหัสผ่านใหม่",
    "settings.confirmNewPassword": "ยืนยันรหัสผ่านใหม่",
    "settings.savePassword": "บันทึกรหัสผ่าน",
    "settings.passwordIncomplete": "กรุณากรอกช่องรหัสผ่านให้ครบ",
    "settings.passwordMismatch": "รหัสผ่านใหม่ทั้งสองช่องไม่ตรงกัน",
    "settings.passwordUnchanged": "รหัสผ่านใหม่ต้องต่างจากรหัสผ่านปัจจุบัน",
    "settings.passwordUpdated": "เปลี่ยนรหัสผ่านแล้ว",
    "settings.passwordFailed": "เปลี่ยนรหัสผ่านไม่สำเร็จ กรุณาตรวจสอบรหัสผ่านปัจจุบันหรือลองอีกครั้งภายหลัง",
    "settings.nlcBannedTitle": "ถูกห้ามใช้ NLC",
    "settings.nlcBannedPrefix": "คุณถูกห้ามใช้ฟีเจอร์นี้ โปรดติดต่อ ",
    "settings.nlcStoppedPrefix": "การใช้งานฟีเจอร์นี้ของคุณถูกระงับ โปรดติดต่อ ",
    "settings.officialSupport": "เจ้าหน้าที่บริการลูกค้า",
    "settings.supportTitle": "บริการลูกค้า",
    "settings.supportIntro": "เลือกเจ้าหน้าที่เพื่อเริ่มสนทนาแบบส่วนตัว",
    "settings.supportLoading": "กำลังโหลดรายชื่อเจ้าหน้าที่…",
    "settings.supportEmpty": "ขณะนี้ไม่มีเจ้าหน้าที่บริการลูกค้า",
    "settings.supportOnline": "ออนไลน์",
    "settings.supportOffline": "ออฟไลน์",
    "settings.supportLoadFailed": "โหลดรายชื่อเจ้าหน้าที่บริการลูกค้าไม่สำเร็จ"
  },
  "vi": {
    "settings.title": "Cài đặt",
    "settings.menu": "Menu cài đặt",
    "settings.notifications": "Thông báo",
    "settings.changePassword": "Đổi mật khẩu",
    "settings.wallet": "Quản lý ví",
    "settings.language": "Đổi ngôn ngữ",
    "settings.feedback": "Báo cáo vấn đề",
    "settings.comingSoon": "Sắp có",
    "settings.comingSoonSentence": "Tính năng này sẽ được mở sau.",
    "settings.currentPassword": "Mật khẩu hiện tại",
    "settings.newPassword": "Mật khẩu mới",
    "settings.confirmNewPassword": "Xác nhận mật khẩu mới",
    "settings.savePassword": "Lưu mật khẩu",
    "settings.passwordIncomplete": "Vui lòng điền đầy đủ các ô mật khẩu.",
    "settings.passwordMismatch": "Hai mật khẩu mới không khớp.",
    "settings.passwordUnchanged": "Mật khẩu mới phải khác mật khẩu hiện tại.",
    "settings.passwordUpdated": "Đã đổi mật khẩu.",
    "settings.passwordFailed": "Không thể đổi mật khẩu. Hãy kiểm tra mật khẩu hiện tại hoặc thử lại sau.",
    "settings.nlcBannedTitle": "Bị cấm sử dụng NLC",
    "settings.nlcBannedPrefix": "Bạn bị cấm sử dụng tính năng này. Vui lòng liên hệ ",
    "settings.nlcStoppedPrefix": "Quyền sử dụng tính năng này của bạn đã bị tạm dừng. Vui lòng liên hệ ",
    "settings.officialSupport": "nhân viên chăm sóc khách hàng",
    "settings.supportTitle": "Chăm sóc khách hàng",
    "settings.supportIntro": "Chọn nhân viên để bắt đầu cuộc trò chuyện riêng.",
    "settings.supportLoading": "Đang tải danh sách nhân viên…",
    "settings.supportEmpty": "Hiện không có nhân viên chăm sóc khách hàng.",
    "settings.supportOnline": "Trực tuyến",
    "settings.supportOffline": "Ngoại tuyến",
    "settings.supportLoadFailed": "Không thể tải danh sách nhân viên chăm sóc khách hàng."
  },
  "zh_hans": {
    "settings.passwordIncomplete": "请填写完整密码",
    "settings.passwordMismatch": "两次输入的新密码不一致",
    "settings.passwordUnchanged": "新密码不能和当前密码相同",
    "settings.passwordUpdated": "密码已更新",
    "settings.passwordFailed": "密码修改失败，请检查当前密码或稍后重试"
  },
  "zh_hant": {
    "settings.passwordIncomplete": "請完整填寫密碼",
    "settings.passwordMismatch": "兩次輸入的新密碼不一致",
    "settings.passwordUnchanged": "新密碼不能與目前密碼相同",
    "settings.passwordUpdated": "密碼已更新",
    "settings.passwordFailed": "密碼修改失敗，請檢查目前密碼或稍後重試"
  },
  "en": {
    "settings.passwordIncomplete": "Please fill in all password fields.",
    "settings.passwordMismatch": "The new passwords do not match.",
    "settings.passwordUnchanged": "The new password must differ from the current password.",
    "settings.passwordUpdated": "Password updated.",
    "settings.passwordFailed": "Could not change the password. Check your current password or retry later."
  }
};
